import CATEGORIES from '@constants/category';
import ROUTER from '@constants/router';
import { addressSelector } from '@stores/address';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './main.module.scss';

export default function MainContainer() {
  const { t } = useTranslation();
  const { currentAddress } = useSelector(addressSelector);
  const router = useRouter();
  const moveCategory = (category: string) => {
    if (!currentAddress || !currentAddress.lat || !currentAddress.lng) {
      router.push({ pathname: ROUTER.address });
      return;
    }
    router.push({
      pathname: ROUTER.restaurants(category),
      query: { lat: currentAddress?.lat, lng: currentAddress?.lng },
    });
  };
  return (
    <div className={styles.categoryContainer}>
      <ul className={styles.categoryWrapper}>
        {CATEGORIES.map((category) => (
          <li key={category.key} className={styles.categoryItem}>
            <div
              aria-disabled={!!!currentAddress}
              onClick={() => moveCategory(category.key)}
            >
              <div className={styles.categoryItemImage}>
                <Image
                  src={category.image}
                  alt={category.key}
                  width={80}
                  height={80}
                />
              </div>
              <span>
                {category?.label && t(`categories:${category.label}`)}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
